const blocks = document.querySelectorAll(
  ".wp-block-adspire-ai-blog-posts"
);

if (blocks.length) {
  import("./view-frontend").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
